import { NavButton } from './NavButton'

const SpeakButton: React.FC<{ id: string; disabled?: boolean; handleOnClick?: (data: string) => void }> = ({ id, disabled, handleOnClick }) => {
    return (
        <NavButton
            id={id}
            text='Speak'
            path='/teacher/classroom'
            icon={'HomeRounded'}
            disabled={disabled}
            onClick={() => {
                if (handleOnClick) {
                    handleOnClick('/teacher/classroom')
                }
            }}
        />
    )
}

export { SpeakButton }
